import React from 'react'
import { DropButton as DropButtonG } from 'grommet'
import { Analytics } from 'grommet-icons'
import WheelTabs from '../WheelTabs'
import styled from 'styled-components'

const DropButton = styled(DropButtonG)`
  @media (max-width: 900px) {
    display: none;
  }
`

const NewWheelButton = ({ page }) => {
  return (
    <DropButton
      secondary
      gap=".8rem"
      style={{ padding: '.8rem 1.5rem', fontWeight: 500 }}
      alignSelf="stretch"
      icon={<Analytics color="iconDarkLight" size="18px" />}
      dropAlign={{ top: 'bottom', right: 'right' }}
      dropProps={{ stretch: false }}
      // open={shareOpen}
      // onOpen={onShareOpen}
      // onClose={onShareClose}
      dropContent={
        // <Box height="50rem" width="20rem">
        <WheelTabs page={page} />
        // </Box>
      }
      label="Switch Wheel"
    />
  )
}

export default NewWheelButton
